export default "__VITE_ASSET__DaozW4bR__"